import { atom } from "recoil";
export const factoryState = atom({
    key: "factoryState", // unique ID (with respect to other atoms/selectors)
    default: "", // default value (aka initial value)
});
